import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AuthUiService {
  private subject = new Subject<boolean>();

  constructor() {}

  setAuthPageUI(flag: boolean) {
    this.subject.next(flag);
  }

  getAuthPageUI(): Observable<boolean> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-services/auth-ui.service.ts